<template>
  <button
    class="simple-button"
    :class="[type, size, { disabled, active, outline }]"
    :style="customStyles"
    :disabled="disabled"
    @click="$emit('click', $event)"
  >
    <i v-if="icon" :class="icon" size="16" class="icon"></i>
    <span v-if="text" class="text" :style="{ fontSize: fontSize }">{{
      text
    }}</span>
  </button>
</template>

<script>
export default {
  name: "CustomButton",
  props: {
    // 按钮文本
    text: {
      type: String,
      default: "",
    },
    // 图标名称
    icon: {
      type: String,
      default: "",
    },
    // 按钮类型
    type: {
      type: String,
      default: "default",
      validator: (val) =>
        ["default", "primary", "success", "warning", "danger"].includes(val),
    },
    // 按钮尺寸
    size: {
      type: String,
      default: "medium",
      validator: (val) => ["small", "medium", "large"].includes(val),
    },
    // 新增字体大小属性
    fontSize: {
      type: [Number, String],
      default: "13px",
    },
    // 是否禁用
    disabled: {
      type: Boolean,
      default: false,
    },
    // 是否激活状态
    active: {
      type: Boolean,
      default: false,
    },
    // 是否镂空按钮
    outline: {
      type: Boolean,
      default: false,
    },
    // 自定义样式
    customStyle: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    customStyles() {
      return { ...this.customStyle };
    },
  },
};
</script>

<style scoped>
.simple-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s ease;
  outline: none;
  /* 新增：镂空按钮样式 */
  outline: 1px solid transparent;
}

/* 图标样式 */
.icon {
  margin-right: 6px;
}

/* 尺寸样式 */
.small {
  height: 32px;
}

.medium {
  height: 36px;
}

.large {
  height: 40px;
}

/* 类型样式 */
.default {
  background-color: #f5f7fa;
  color: #4e5969;
}

.primary {
  background-color: #409eff;
  color: #fff;
}

.success {
  background-color: #52c41a;
  color: #fff;
}

.warning {
  background-color: #faad14;
  color: #fff;
}

.danger {
  background-color: #f5222d;
  color: #fff;
}
/* 新增：镂空按钮样式（覆盖基础背景，添加边框） */
.outline {
  background-color: transparent !important;
  border: 1px solid; /* 边框宽度统一，颜色继承对应type的文字色 */
}
/* 为不同type的镂空按钮设置边框色 */
.outline.default {
  border-color: #4e5969;
  color: #4e5969;
}
.outline.primary {
  border-color: #409eff;
  color: #409eff;
}
.outline.success {
  border-color: #52c41a;
  color: #52c41a;
}
.outline.warning {
  border-color: #faad14;
  color: #faad14;
}
.outline.danger {
  border-color: #f5222d;
  color: #f5222d;
}
/* 状态样式 */
.disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.active {
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.3);
}

/* 交互效果 */
.simple-button:not(.disabled):hover {
  opacity: 0.9;
  transform: translateY(-1px);
}

.simple-button:not(.disabled):active {
  transform: translateY(0);
}
/* 新增：镂空按钮专属hover效果（区分普通按钮） */
.outline.simple-button:not(.disabled):hover {
  opacity: 1; /* 取消原有透明度变化 */
  background-color: rgba(0, 0, 0, 0.02) !important; /* 浅灰色背景 */
  transform: translateY(-1px);
}
.outline.simple-button:not(.disabled):active {
  transform: translateY(0);
}
/* 为不同type的镂空按钮添加hover背景色（更贴合主题） */
.outline.primary:not(.disabled):hover {
  background-color: rgba(64, 158, 255, 0.1) !important;
}
.outline.success:not(.disabled):hover {
  background-color: rgba(82, 196, 26, 0.1) !important;
}
.outline.warning:not(.disabled):hover {
  background-color: rgba(250, 173, 20, 0.1) !important;
}
.outline.danger:not(.disabled):hover {
  background-color: rgba(245, 34, 45, 0.1) !important;
}
</style>
